export default __webpack_public_path__ + "static/media/google.dacf56a9.svg";